import Wix from 'Wix';
import {getFileByFileId} from '../../../../widget/api/GoogleDriveApi';
import {insertPermission, isFilePublic} from '../../../../widget/api/PermissionsAPI';
import wixService from '../../../../utils/wixService';


const onOpenModalPicker = (_this) => { 
    
    const isEditorStudio = wixService.getParamFromURL('origin') === 'studio';
    const popupUrl = window.location.protocol + "//" + window.location.host + `/settings/popup?isEditorStudio=${isEditorStudio}`;
    const onClose = (props) => {
        if(props && props.fileId) {
            isFilePublic(props.fileId,(isPublic) => {
                if (!isPublic) {
                    getFileByFileId(props.fileId ,props.resourceKey,  (item) => {
                        if(item) {
                            if (props.ownedByMe) {
                                onOpenModalChangeToPublic(
                                    _this, 
                                    props.fileId, 
                                    props.datapublicObj, 
                                    props.dataFile,
                                    props.title
                                );
                            } else {
                                onOpenModalChangeToPublicWait(
                                    props.datapublicObj.isSignleFile,
                                    _this,
                                    props.noPermissionTitle
                                );
                            }
                        }
                    },true);
                } else {
                    setNewFileSelected(_this, props.datapublicObj, props.dataFile);
                }
            },true);
        }
    };
        Wix.SuperApps.Settings.openModal(popupUrl, 1002, 642, "", onClose , true);
};

const onOpenModalChangeToPublic = (_this, fileId, datapublicObj, dataFile, title) => {

    let type;
    if (datapublicObj.isSignleFile) {
        type = 'File'
    }
    else {
        type = 'Folder'
    }
    const compId = Wix.Utils.getOrigCompId();
    const popupUrl = window.location.protocol + "//" + window.location.host + `/settings/share/${type}`;
    const onClose = (changeToPublic) => {
       
      if(changeToPublic && type=="Folder"){
           window.open('https://drive.google.com/','_blank');
       }
      if(changeToPublic && type == "File") {
            insertPermission(fileId, 'default', 'anyone', 'reader', (resp) => {  
                if(resp.kind === "drive#permission") {
                    setNewFileSelected(_this, datapublicObj, dataFile);
                }
                else{
                    onOpenModalChangeToPublicWait(
                        datapublicObj.isSignleFile,
                        _this 
                    );
                }
            });
        }
        else {
            const dataLoader = { key: 'stoploader', value: {"compId": compId} };
            Wix.Settings.triggerSettingsUpdatedEvent(dataLoader, compId);
        }
    };
    Wix.Settings.openModal(popupUrl, 602, 198, title, onClose);
};
const onOpenModalChangeToPublicWait = (isSignleFile,_this, title) => {
    const compId = Wix.Utils.getOrigCompId();
    const type = isSignleFile ? 'File' : '';
    const popupUrl = window.location.protocol + "//" + window.location.host + `/settings/share/publicwait${type}`;

     const onClose = (selectAnotherItem) => {
        const dataLoader = { key: 'stoploader', value: {"compId": compId} };
        Wix.Settings.triggerSettingsUpdatedEvent(dataLoader, compId);
        if(selectAnotherItem){
            onOpenModalPicker(_this)
        }
    };
    Wix.Settings.openModal(popupUrl, 600,178, title, onClose);
};
const onOpenModalEdit =(isSignleFile, title, callback) => {
    const type = isSignleFile ? 'File' : '';
    //const popupUrl = `${process.env.REACT_APP_BASE_URL}/settings/share/edit${type}`;
    const popupUrl = window.location.protocol + "//" + window.location.host + `/settings/share/edit${type}`;

     const onClose = (changeRole) => {
        callback(changeRole);  
    };
   // const typeText = type===''?'Folder':'File';

    Wix.Settings.openModal(popupUrl, 600,178, title, onClose);
};
const onOpenModalWait = (isSignleFile, title, onClose) => {
    const type = isSignleFile ? 'File' : '';
    const popupUrl = window.location.protocol + "//" + window.location.host + `/settings/share/wait${type}`;
    Wix.Settings.openModal(popupUrl, 600,178, title, onClose);
};
const setNewFileSelected = (_this, datapublicObj, dataFile) => {    
    _this.props.setDataPublic(datapublicObj);
    Wix.Settings.triggerSettingsUpdatedEvent(dataFile);
};


export {
    onOpenModalPicker,
    onOpenModalEdit,
    onOpenModalWait,
    onOpenModalChangeToPublicWait,
    setNewFileSelected
};



// WEBPACK FOOTER //
// ./src/settings/Containers/gdUnitControlPanel/modules/helperFunction.js